import BaseModel from 'src/model/base.model';

export interface IWarrantyProvider {
  providerNumberString: string;
  providerNumber: number;
  warrantyClaimNumber: string;
}

export interface IWarrantyCheck {
  warrantyProvider: string;
  warrantyRegexp: string;
  errorMessage: string;
}

class WarrantyModel extends BaseModel {
  public warrantyProviders: IWarrantyProvider[] = [];
  public warrantyChecks: IWarrantyCheck[] = [];
}

export default WarrantyModel;
